import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { GameDetails, GameDetailsScore } from '../domain/interfaces/GameDetails';
import { GameEventDTO } from '../domain/interfaces/GameEventDTO';
import gameRepository from '../domain/repositories/game-repository';

const PREFIX = 'GAMES';

export const fetchGameDetails = createAsyncThunk<GameDetails | null, { gameId: number }>(
  `${PREFIX}/fetchDetails`,
  async (payload) => {
    try {
      return await gameRepository.fetchGameDetails(payload.gameId);
    } catch (err) {
      throw err;
      console.error(`${PREFIX}/fetchDetails error:`, err);
      return null;
    }
  },
);

export const addGameEvent = createAction<GameEventDTO>(`${PREFIX}/addGameEvent`);
export const editGameEvent = createAction<GameEventDTO>(`${PREFIX}/editGameEvent`);
export const deleteGameEvent = createAction<number>(`${PREFIX}/deleteGameEvent`);
export const editGameScore = createAction<GameDetailsScore>(`${PREFIX}/editGameScore`);

export const changeGameDetailsVideoUrl = createAction<string>(`${PREFIX}/changeGameDetailsVideoUrl`);

export const saveGameDetails = createAsyncThunk<GameDetails, GameDetails>(
  `${PREFIX}/saveGameDetails`,
  async (payload) => {
    try {
      const eventsPlayerIds = payload.events
        .reduce<number[]>((results, event) => ([
          ...results,
          ...event.playerIds,
        ]), [])
        .filter(Boolean);

      const oldParticipantIds = payload.participants;
      const newParticipantIds = Array.from(new Set([...oldParticipantIds, ...eventsPlayerIds]));
      const participantsChanged = newParticipantIds.some((id) => !oldParticipantIds.includes(id));

      if (participantsChanged) {
        await gameRepository.updateMatchParticipants(payload.id, newParticipantIds);
      }

      return await gameRepository.updateGameDetails(payload);
    } catch (err) {
      console.error(`${PREFIX}/saveGameDetails error:`, err);
      throw err;
    }
  },
);
